import { render, staticRenderFns } from "./CampaignTypeBadge.vue?vue&type=template&id=3c323292&"
import script from "./CampaignTypeBadge.vue?vue&type=script&lang=ts&"
export * from "./CampaignTypeBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports